import create from 'zustand';
import { IChatUtilsStore } from './types';

const chatUtilsStore = create<IChatUtilsStore>((set) => ({
  showRightSidebar: false,
  showSearchMember: false,
  showInviteLink: false,
  showAddMember: false,
  showNewMessage: false,
  showUserSelection: false,
  showCreateGroup: false,
  showModalLeaveGroup: false,
  showEditRoomChat: false,
  isComposeChatFocused: false,
  setComposeChatFocuses: (focused: boolean) => {
    set({ isComposeChatFocused: focused });
  },
  toggleRightSidebar: (visible) => {
    set({ showRightSidebar: visible });
  },
  toggleSearchMember: (visible) => {
    set({ showSearchMember: visible });
  },
  toggleInviteLink: (visible) => {
    set({ showInviteLink: visible });
  },
  toggleAddMember: (visible) => {
    set({ showAddMember: visible });
  },
  toggleNewMessage: (visible) => {
    set({ showNewMessage: visible });
  },
  toggleUserSelection: (visible) => {
    set({ showUserSelection: visible });
  },
  toggleCreateGroup: (visible) => {
    set({ showCreateGroup: visible });
  },
  toggleModalLeaveGroup: (visible) => {
    set({ showModalLeaveGroup: visible });
  },
  toggleEditRoomChat: (visible) => {
    set({ showEditRoomChat: visible });
  },
  resetLeftSidebarView: () => {
    set({
      showCreateGroup: false,
      showNewMessage: false,
      showUserSelection: false,
    });
  },
  resetRightSidebarView: () => {
    set({
      showRightSidebar: false,
      showSearchMember: false,
      showInviteLink: false,
      showAddMember: false,
    });
  },
}));

export default chatUtilsStore;
